<img appHideOnError *ngIf="icon" [src]="path" title="age-rating-icon">